var map = {
	"./logo_BB.png": 8663,
	"./logo_FF.png": 4669,
	"./logo_FFA.png": 2489,
	"./logo_LMAD.png": 4802,
	"./logo_MD.png": 1996,
	"./logo_S.png": 8558,
	"./logo_TPIR.png": 2465,
	"./logo_betmgm.png": 2349,
	"./logo_everi.png": 755,
	"./logo_fanduel.png": 4703,
	"./logo_traitors.png": 1377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8750;